export const globalItems = [
  { id: "header", name: "argen.globalItems.header", icon: "header" },
  { id: "footer", name: "argen.globalItems.footer", icon: "footer" },
  { id: "menu", name: "argen.globalItems.menu", icon: "menu" },
  { id: "mobileBar", name: "argen.globalItems.mobileBar", icon: "mobile" },
  { id: "support", name: "argen.globalItems.support", icon: "support" },
]

export const globalItemsMeta = {
  header: { name: "argen.globalItemsMeta.header.name", description: "argen.globalItemsMeta.header.description" },
  footer: { name: "argen.globalItemsMeta.footer.name", description: "argen.globalItemsMeta.footer.description" },
  menu: { name: "argen.globalItemsMeta.menu.name", description: "argen.globalItemsMeta.menu.description" },
  mobileBar: { name: "argen.globalItemsMeta.mobileBar.name", description: "argen.globalItemsMeta.mobileBar.description" },
  support: { name: "argen.globalItemsMeta.support.name", description: "argen.globalItemsMeta.support.description" },
}

export const headerComponents = {
  left: [{ key: "search", label: "argen.headerComponents.search" }],
  right: [{ key: "categories", label: "argen.headerComponents.categories" }],
  third: [
    { key: "profileButton", label: "argen.headerComponents.registrationButton" },
    { key: "search", label: "argen.headerComponents.search" },
  ],
}

export const socialNetworks = []

export const supportNetworks = [
  { key: "whatsapp", label: "Whatsapp" },
  { key: "email", label: "Email", icon: "email" },
  { key: "telegram", label: "mell.socialNetworks.telegram" },
  { key: "vk", label: "mell.socialNetworks.vk" },
  { key: "kyc_email", label: "KYC Email" },
]
